module.exports = __webpack_public_path__ + "static/media/container.2e2ddfde.svg";